import { EntityModel } from '@/interfaces'
import {
  ALL_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
  CREATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
  DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
  FORCE_DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
  SINGLE_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
  UPDATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
} from './graphql'

const travelDocumentationServicesModel: EntityModel = {
  name: 'travelDocumentationServices',
  namePlural: 'travelDocumentationServices',
  uniqueName: 'travelDocumentationServices',
  uniqueNamePlural: 'travelDocumentationServices',
  path: 'config/ratio/travel_documentation_services',
  baseUrl: '/config/ratio/travel_documentation_services',
  translationPrefix: 'entities:travelDocumentationServices.',
  getDisplayName: (values: any) => {
    return 'Ratio Travel Documentation Services'
  },
  gql: {
    getAll: ALL_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
    getSingle: SINGLE_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
    create: CREATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
    update: UPDATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
    delete: DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
    forceDelete: FORCE_DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
  },
  attributes: {
    printServiceNo: {
      name: 'printServiceNo',
      label: 'entities:travelDocumentationServices.attributes.printServiceNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    electronicServiceNo: {
      name: 'electronicServiceNo',
      label: 'entities:travelDocumentationServices.attributes.electronicServiceNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default travelDocumentationServicesModel
